import React, { useEffect,  useRef, useState } from "react";
import h5Share from '@/utils/h5Share'
import styled from "styled-components";
import Header from "@/components/Header";

import styles from '@/styles'
import Goods from './goods.json';
import GoodsBg from './imgs/goods_bg.png';
import GoodsBg2 from './imgs/goods_bg_active.png';
import buyBg from './imgs/buyBg.png';
import buyBg2 from './imgs/buyBg2.png';

// import { useHistory } from 'react-router'

// import { ComfirmContainer} from './style';
import { Toast } from "antd-mobile";
import { jumpTo, userBehaver } from "../../utils";
import Bg2 from './imgs/bg2@2x.png'
import bwmodel from '@/config/bwmodel'
import bridge from '@/config/JSbridge'
import { connect } from 'react-redux'

import OpenApp from '../../components/OpenApp';
// import { getActivityUserInfo } from '@/api/user-new'
import {  fetchEductionVip } from "./api"
export const isStorm = bwmodel.app === 'storm';

const active_id = 136;

const ShopContainer = ({token,userId}) => {
  const [activeVisible, setActiveVisible] = useState(true) // 活动是否进行
  const [goodsList, setGoodsList] = useState([]);
  // const [ timeOver, setTimeOver ] = useState(null)
  const [isVisible, setIsVisible] = useState(false);
   const triggerRef = useRef(null);
  const bodyContainer = useRef()
  


  const [showFooter, setShowFooter] = useState(false); // 是否购买
  const [showCoupon, setShowCoupon] = useState(true); // 显示99元

  const [activeGoods, setActiveGoods] = useState({});
  const [isOverTime, setIsOverTime] = useState(false);
  const [finishTime, setFinishTime] = useState({});
  // 1764833629000
  // const detentionRef = useRef();
  // const clockRef = useRef();
useEffect(() => {
    const handleScroll = () => {
    
      console.log(isVisible);
      
      if (triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        if (rect.top <= 0) {
        console.log(isVisible);
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    document.title = '历史低价，快抄底！'
    h5Share.main({
      title: `「特价秒杀」99元风云大会员体验风暴来袭！`,
      desc:  '限时抄底风云会员，得7天会员+任意1款周边+全场会员年卡立减1000元，活动结束后恢复原价',
      link: process.env.REACT_APP_DEMAND_URL + 'active_136',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo16.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
  }, [])


  const initPage = () => {
    let goodsList = Goods.map((it,index) => it)
    setGoodsList(goodsList);
    setShowFooter(false)
    getData()

  }
  let getData = () => {

    userBehaver({
      activeIdKey: "Activity_View",
      conId: `8401`,
      userId: userId,
      active_id: active_id,
      time: new Date()

    });


      fetchEductionVip({})
        .then(res => {
          if(res.data.isTaskFinished === 0) {
            setShowCoupon(true)
            setShowFooter(false)
          } else if(res.data.isTaskFinished === 1){
              // (true)
          let activeGoods = Goods[0];
          setActiveGoods(activeGoods);
            setShowCoupon(false)
            setShowFooter(true)
            const buyTime = res.data.finishTime; // 购买时间
            let nowTime = new Date().getTime(); // 当前时间戳
            const daysTime7 = 7 * 24 * 60 * 60 * 1000 + buyTime; // 7天后时间戳
          
            if(daysTime7 > nowTime) {
              setIsOverTime(false)
              const timer = setInterval(()=> { 
               
                nowTime += 1000;
                if(daysTime7 > nowTime) {
                  let dd=0, hh = 0,mm = 0,ss = 0;
                  dd = Math.floor((daysTime7 - nowTime)/(24 * 60 * 60 * 1000));
                  hh = Math.floor((daysTime7 - nowTime)/(60 * 60 * 1000)%24);
                  mm = Math.floor((daysTime7 - nowTime)%(60 * 60 * 1000)/(60 * 1000));
                  ss = Math.floor((daysTime7 - nowTime)%(60 * 1000)/1000);
                  
                  setFinishTime({
                    dd: dd,
                    hh: hh,
                    mm: mm,
                    ss: ss
                  });
                  
                } else {
                  clearInterval(timer);
                  setFinishTime({});
                  setIsOverTime(true)
                }
              }, 1000);
            } else {
              setIsOverTime(true)
            }
            
          } else {
            setActiveGoods({});
            setShowFooter(false)
            setIsOverTime(true)
            setShowCoupon(false)
          }

        })
  }


  useEffect(()=> {
    setGoodsList(Goods);
  },[]);

  useEffect(()=> {
    initPage();
    bridge.addRegisterHandler([
      {
        name: 'viewWillAppear',
        callback: (res) => {
          initPage();
          // clockRef.current.refresh();
        }
      },
    ])

    setActiveVisible(true);
  },[])


  function handleScroll(e) {
    let footer = document.getElementById('footer');
    if(footer) {
      if(window.scrollY >=20) {
        footer.classList.add('footer-freeclass-block');
      }else {
        footer.classList.remove('footer-freeclass-block');
      }
    }

  }
  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
}, [])

  useEffect(() => {
    document.title = '历史低价，快抄底！'
    h5Share.main({
      title: `「特价秒杀」99元风云大会员体验风暴来袭！`,
      desc:  '限时抄底风云会员，得7天会员+任意1款周边+全场会员年卡立减1000元，活动结束后恢复原价',
      link: process.env.REACT_APP_DEMAND_URL + 'active_136',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo16.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
  }, [])






  const handleAddGoods = (goods) => {
    if(!isStorm) {
      return  Toast.info('请在市值风云App内参与活动');
    }
    if(!token) {
      return Toast.info('请先登录');
    }
    userBehaver({
      activeIdKey: "Activity_Start",
      // conId: active_id,
      userId: userId,
      // active_id: active_id,
      conId: `${active_id}_add_${goods.id}`,
    
    });

    if(!isOverTime) {
      setShowFooter(true)
      setActiveGoods(goods)
    } else {
      Toast.info('优惠已结束');
    }
  

    
    // 已加入购物车，单次购买无法重复
    // if(goods.isBuy) {
    //  return Toast.info('已加入购物车，单次购买无法重复',1)
    // }
    // if(cartGoods.length === 0) {
    //   Toast.success('会员与周边1套已加入购物车',1)
    // }

    // if(cartGoods.length === 3) {
    //   return  childRef.current.show();
    // }
    // // 购物车的商品，与下面联动
    // setCartGoods(goods);

    // setGoodsList(goodsMap);
    // const goodsMap = goodsList.map((it,index) => {
    //   if(it.id === goods.id) {
    //     it.isBuy = true;
    //     const skuIds = [...skuId];
    //     skuIds[index] = 1;
    //     const num = skuIds.reduce(function (a,b) {
    //       return a + b
    //     });

    //     setNum(num);

    //     localStorage.setItem('active136_goods_num', JSON.stringify(num))

    //     setSkuId(skuIds);

    //     localStorage.setItem('active136_skuIds',JSON.stringify(skuIds))

    //     let cartGoodsList = [...cartGoods];

    //     const result = cartGoodsList.filter(it => it.id === goods.id)
    //     if(!result || result.length===0) {
    //       let money = 0;
    //       cartGoodsList.push(goods);
    //       setCartGoods(cartGoodsList);
    //       // cartGoodsList.forEach(a => money += (a.price - 1000));

    //       const len = cartGoodsList.length;

    //       localStorage.setItem('active136_goods_list', JSON.stringify(cartGoodsList))

    //       if(len <= 3) {
    //         cartGoodsList.forEach((a,index) => money += (a.price - 1000));
    //         money = money + len -1;
    //       }else {
    //         cartGoodsList.forEach((a,index) => money += a.price );
    //         money =  money - 3888;
    //       }
    //       setCoupon(money);

    //     }
    //   }
    //   return it;
    // })

    // setGoodsList(goodsMap);


  }


  // }
  const handleSettle = () => {
    if(!isStorm) {
      return Toast.info('请在市值风云App内参与活动')
    }
    if(!token) {
      return Toast.info('请先登录');

    }
    try {
      if(showCoupon) {      // 如果没有买券  
        const goods = {
          skuPrice: '99',
          goodsName: '会员卡',
          skuId: '175',
          goods: '1'
        }
         bridge.callHandler('nativeEvent', {
            event: 'halfScreenPay',
            params: {
              price: `${goods.skuPrice}`,
              activityTitle: goods.goodsName,
              skuId: `${goods.skuId}`,
              orderType: `${goods.spuId}`
            },
          }, (params) => {
            try {
              const info = JSON.parse(params)
              if (info && info.params.result) {
                initPage();
              }
            } catch (error) {
              //
            }
          })
      } else {
        console.log(activeGoods);
        
        const goods = activeGoods;
        
        
        bridge.callHandler('nativeEvent', {
          event: 'halfScreenPay',
          params: {
            price: `${goods.price - 1000}`,
            activityTitle: goods.name,
            // iapId: `valuestorm.cloudconch.${goods.price - 1000}`,
            skuId: `${goods.id}`,
            orderType: `${goods.spu_id}`
          },
        }, (params) => {
          try {
            const info = JSON.parse(params)
            if (info && info.params.result) {
              initPage()
            }
          } catch (error) {
            //
          }
        })
      }
    } catch(e) {
      console.log(e);
    }
 }


  // const handleLeftClick = () => {

  // //   // const bool =  showPopMenu && (count===0);
  // bridge.callHandler('nativeEvent', {event: 'close', params: {
  //       isDelete: false
  //     }}, () => {})


  // }

  // 挽留了


  const activityShare = (callback) => {
    bridge.callHandler('nativeEvent', {
      event: 'shareLink',
      params: {
        title: `「特价秒杀」99元风云大会员体验风暴来袭！`,
        desc:  '限时抄底风云会员，得7天会员+任意1款周边+全场会员年卡立减1000元，活动结束后恢复原价',
        thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
        linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_136',
      },
    }, () => {
      // handleUploadTrace('share', 'click');

      callback && callback();
    })
  }


  return <Container style={isStorm ? {} : {paddingTop: '40px'}} className={activeVisible? '': 'filter'} ref={bodyContainer}>

    <div  className='page-body' >
      {isStorm &&
        <Header
          title="历史低价，快抄底！"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
       
          bg_color={styles.bg_color2}
        />
      }
    

      <div
        className="rules_btn"
        style={{top: '180px'}}
        onClick={
          ()=>jumpTo('https://s.wogoo.com/3vD0pS')
        }
      ><span>了</span><span>解</span><span>会</span><span>员</span></div>
      <div className="img_box">
        <img style={{marginTop: '-40px'}} src={require(`./imgs/bg1.png`)} alt=''/>
      </div>
     {
      showCoupon ? <div className="bgBox">     
          <img  src={require(`./imgs/tips1.png`)} alt=''/>
          <img  src={require(`./imgs/tips2.png`)} alt=''/>
          {/* <div  ref={triggerRef}  className="submitBar submitBar2">
            <div className="submit_left">
              <div className="tips">限时价</div>
              <div className="price_box">¥ <span className="price">99</span></div>
            </div>
            <div className="buy" 
              onClick={()=> {
                handleSettle()
              }}
            >畅享7天风云会员权益</div>
          </div> */}
          <img  src={require(`./imgs/allGoods.png`)} alt=''/>
             <img  onClick={
          ()=>jumpTo('https://s.wogoo.com/3vD0pS')
        } src={require(`./imgs/tips4.png`)} alt=''/>
          <img  src={require(`./imgs/rules.png`)} alt=''/>
        </div>:<div className="goods_box">
            <img  src={require(`./imgs/tips3.png`)} alt=''/>
          {
            goodsList.map(it => {
         return <GoodsCard onClick={()=> {
                handleAddGoods(it);
              }} className={ activeGoods.id === it.id ? 'active' : null}>
            <div className="img_box"
               
            >
               {
                activeGoods.id === it.id ? <img src={require(`./imgs/${it.img}`)} alt=""></img>:
                 <img src={require(`./imgs/${it.img2}`)} alt=""></img>
               }
             
            </div>
            <div className="content"
            
            >
              <div className="title"><span className="name">{it.name1}</span><span className="days">+已省1000元</span></div>
              <div><span className="price1">¥{it.price - 1000}</span><span className="price2">原价¥{it.price}</span></div>
            </div>
            <div
              className={it.isBuy ? 'button_box buy': 'button_box'}
             
            >{
              isOverTime? <img src={require(`./imgs/buy3.png`)} alt="" />:<div className="clock_box">
                <div className="clock_text">
                  {
                    activeGoods.id === it.id? <img className="clock" src={require(`./imgs/clock.png`)} alt=""/>:
                     <img className="clock" src={require(`./imgs/clock2.png`)} alt=""/>
                  }
                  倒计时 
               </div>
              <div>
               {
                finishTime.dd >0?<div><span>{finishTime.dd}</span>天<span>{finishTime.hh}</span>小时</div>: <React.Fragment>{
                    finishTime.hh >0?<div><span>{finishTime.hh}</span>小时<span>{finishTime.mm}</span>分</div>:
                  <div><span>{finishTime.mm}</span>分<span>{finishTime.ss}</span>秒</div>
                }
                </React.Fragment>
               }</div>
              </div>
              }</div>
          </GoodsCard>
        }) }
         <img  src={require(`./imgs/rules.png`)} alt=''/>
   </div>      
 }
     
    </div>
    
    
    {
      showFooter && activeGoods.id && 
      <CardFooter className="bg">
      <div className="submitBar submitBar2 ">
        <div className="submit_left">
          <div className="tips tips2">原价{activeGoods.price}</div>
          <div className="price_box">¥ <span className="price">{activeGoods.price - 1000}</span></div>
          <div className="price_box price_box2">已减1000</div>
        </div>
        <div className="buy" 
          onClick={()=> {
            handleSettle()
          }}
        >立即购买</div>
      </div>
          </CardFooter>
    }

    {
      showCoupon  &&  <CardFooter>
         <div className="submitBar breathe  submitBar2">
        <div className="submit_left">
          <div className="tips">限时价</div>
          <div className="price_box">¥ <span className="price">99</span></div>
        </div>
        <div className="buy" 
          onClick={()=> {
            handleSettle()
          }}
        >畅享7天风云会员权益</div>
      </div>
          </CardFooter>
    }

    {
      !isStorm &&
      <div>
        <OpenApp  bottom='bottom' url={`${process.env.REACT_APP_DEMAND_URL}active_136`}></OpenApp>
      </div>
      }
  </Container>;
}


const mapStateToProps = (state) => ({
  token: state.user.accessToken || 'xx',
  userId: state.user.userId || '',
});

export default React.memo(connect(mapStateToProps)(ShopContainer))
// export default React.memo(ShopContainer)


const Container = styled.div`
  position: relative;
  background: #E93E2F;
  padding-top: 80px;
 
  .rules_btn {
    position: absolute;
    z-index:100;
    right: 0;
    top: 100px;
    width: 18px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 11px;
    color: #FFFFFF;
    background-image: url(${Bg2});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border: 6px solid transparent;
    border-right: none;
  }
  .isAllVip {
    position: fixed;
    right: 5px;
    bottom: 120px;
    width: 80px;
    z-index: 100;
  }
  img {
    user-select: none;
  }
  .bgBox {
    width: 100%;
    background-size: 100% 517px;
    background-repeat: no-repeat;
    z-index: 1;
    position: relative;
    margin-top: -75vw;
    padding: 5vw;
    padding-bottom: 150px;
    box-sizing: border-box;
    overflow: hidden;
    img { 
      max-width: 100%;
    }
    
  }
  .goods_box {
    >img {
      display: block;
      margin: 0 auto;
      max-width: 81.33vw;
    }
    position: relative;
    margin-top: -75vw;
    padding-bottom: 150px;
   
  }
  .share-img {
    width: 20px;
    vertical-align: middle;
  }
  .img_box {
    min-width: 80px;
    img{
      font-size:0px;
      vertical-align: middle;
      width: 100%;
    }
  }

  .segmentation {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;
    color: #717171;
    text-align: center;
    width:100%;
    position: relative;
    height: 20px;
    padding:0 14px;
    margin: 10px 0;
    box-sizing: border-box;
    .content {
      position: absolute;
      left: 50%;
      top: 4px;
      display: inline-block;
      background-color:#F1F1F1;
      white-space: nowrap;
      padding:0 20px;
      transform: translateX(-50%);
      
    }
    .line2 {
      border-top: 1px solid #727272 !important;
      display: inline-block;
      width: 100%;
  
    }
  }
    @keyframes breathe {
      0%, 100% { transform: scale(0.98); }
      50% { transform: scale(1.05); }
    }
    .submitBar2{
      height: 48px;
      border-radius: 63px;
      border: 2rpx solid #FFD6A0;
      background: linear-gradient( 165deg, #FEF4EA 60%, #FFE6C1 74%);

      box-sizing: border-box;
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      padding: 0 0px;
      &.breathe {
        .buy {
          color: #B72300;
          background: linear-gradient( 90deg, #FFE570 1%, #FFF4C2 10%);
      
        }

        animation: breathe 1.5s infinite alternate;
      }
      &.breathe1 {
        .price_box {
           color: #fff;
        }
        .submit_left{
          .tips, .price {
            color: #fff;
          }
        }
        background: #D91C0A;
        .buy {
          color: #fff;
          background: linear-gradient( 130deg, #E8953D 0%, #D60500 100%);
        }
      }
    .buy {
      flex: 1;
      height: 48px;
      background: linear-gradient( 173deg, #FFDF4F 1%, #FFFFFF 71%);
      // background: linear-gradient( 130deg, #E8953D 0%, #D60500 100%);
      background: linear-gradient( 173deg, #FFDF4F 1%, #FFFFFF 71%);
      font-weight: bold;
      white-space: nowrap;
      color: #B72300;
      padding:0 20px;
      text-align: center;
      line-height: 48px;
      border-radius: 24px;
    }
    .submit_left {
      display: flex;
      justify-content: space-start; 
      padding: 5px 20px;
      box-sizing: border-box;
      color: #E23D23;
      flex: 1;
      .price {
        font-weight: bold;
        font-size: 36px;
        color: #E23D23;
      }
      .price_box {
        align-self: start;
        display: flex;
        white-space: nowrap;
      }
      .price_box2 {
         align-self: end;
      }
      .tips {
        font-size: 12px;
        align-self: end;
      }
      .tips2 {
       white-space: nowrap;
        color: #5E5E5E;
    text-decoration: line-through;
      }
    }
  }

`;


const GoodsCard = styled.div`
  margin: 12px;
  height: 88px;
  overflow: hidden;
  padding: 0px 7px;
  border-radius: 10px;
  background-image: url(${GoodsBg});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  &.active {
     background-image: url(${GoodsBg2});
      .button_box{
         .clock_box {
              color: #FFFAE6;
              
           background-image: url(${buyBg});
         }
      }
    .title {
      .name {
     
         color: #000000;
      }
      .days {
          color: #FF3E53;
  
      }
    }
    .price1 {
        color: #FF3E53;
    }
    .price2 {
        color: #707070;
    }
  }
  .img_box {
    width: 73px;
    height: 73px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .button_box {
    width: 76px;
    height: 76px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
      position: relative;
    }
    .clock_box {
       width: 76px;
      height: 76px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-image: url(${buyBg2});
   
      color: #FFB462;
      background-size: cover;
      font-size: 10px;
      span {
        font-size: 15px;
      }
    }
    .clock_text {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      img {
        margin-right: 3px;
      }
    }
    .clock {
      display: inline-block;
      width: 10px;
      height: 10px;
    }
    &.buy::after {
        content:'1';
        display: block;
        color: #FFFFFF;
        width: 26px;
        height: 26px;
        position: absolute;
        right: -4px;
        top: -4px;
        font-size: 14px;
        font-weight: bold;
        border: 1px solid #FFFFFF;
        text-align: center;
        line-height: 26px;
        background:#C41825;
        z-index: 100;
        border-radius: 50%;
      }
  }
  .content {
    flex: 1;
    padding-left:6px;
    letter-spacing: -1px;
  }
  .title {
    .name {
      font-family: Alibaba PuHuiTi;
      font-weight: 800;
      font-size: 15px;
     
       color: #777777;
      line-height: 28px;
    }
    .days {
  
       color: #FFB462;
      font-weight: 800;
    }
  }
  .price1 {
    // font-family: Arial Black !important;
    // font-family:system-ui !important;
    font-weight: 700;
    font-size: 20px;

    color: #FFB462;
    line-height: 29px;
    // font-style: italic;
    font-weight: bolder;
  }
  .price2 {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;

    color: #707070;
    line-height: 26px;
    margin-left:4px;
  }
`;

const CardFooter = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 10;
  padding-bottom: 5vw;
  @supports (bottom: constant(safe-area-inset-bottom)){
    padding-bottom: constant(safe-area-inset-bottom)!important;
}
  &.bg {
    padding-top: 10px;
    background: #FFFFFF;
  }
 
  .submitBar {
    position: relative;
    z-index: 20;
    padding: 14px 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-radius: 10px 10px 0px 0px;
    .icon {
      img {
        width: 35px;
      }
    }
  
    .shop_cart {
      position: relative;
      padding-right: 35px;
      border-right: 1px solid #ccc;
      color: #333;
      .num {
        position: absolute;
        right: 20px;
        top: -3px;
        display: inline-block;
        background-color: #C41825;
        min-width: 26px;
        height: 26px;
        box-sizing: border-box;
        line-height: 26px;
        text-align: center;
        padding: 0 5px;
        color: #FFF;
        font-size: 16px;
        border-radius:13px;
        border: 1px solid #fff;
        font-size: 12px;
      }
    }

  .foot-content {
    flex: 1;
    padding-left: 30px;
    font-weight: bold;
    font-size: 18px;
    color: #222222;
    .unit {
      font-weight: bold;
      font-size: 17px;
      color: #FF3E4C;
    }
    .price {
      font-weight: bold;
      color: #FF3E4C;
      font-size: 30px;
    }
    .coupon {
      color: #FF3E4C;
      font-size: 13px;
    }
  }
  .btn {
    width: 94px;
    height: 44px;
    background: linear-gradient(148deg, #FF3061, #FF9000);
    border-radius: 22px;
    text-align: center;
    align-items: center;
    line-height: 44px;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }
}
  .submitBar2{
    height: 48px;
    border-radius: 63px;
    border: 2rpx solid #FFD6A0;
    background: linear-gradient( 165deg, #FEF4EA 60%, #FFE6C1 74%);
    margin: 0 20px;
    display: flex;
    justify-content: space-between;
    padding: 0 0px;
    .buy {
      flex: 1;
      height: 48px;
      background: linear-gradient( 130deg, #E8953D 0%, #D60500 100%);
      // background: linear-gradient( 173deg, #FFDF4F 1%, #FFFFFF 71%);
      //   background: linear-gradient( 180deg, #FFE570, #FFF4C3 100%);
      font-weight: bold;
       white-space: nowrap;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 48px;
      border-radius: 24px;
    }
    .submit_left {
      display: flex;
      justify-content: space-start; 
      padding-left: 20px;
      color: #E23D23;
      flex: 1;
      .price {
        font-weight: bold;
        font-size: 36px;
        color: #E23D23;
      }
      .price_box {
        align-self: start;
        display: flex;
        white-space: nowrap;
      }
      .price_box2 {
         align-self: end;
      }
      .tips {
        font-size: 12px;
        align-self: end;
      }
      .tips2 {
       white-space: nowrap;
        color: #5E5E5E;
    text-decoration: line-through;
      }
    }
  }

  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .goodsList_box {
    background: #F1F1F1;
    border-radius: 15px 15px 0 0;
    overflow: hidden;
    padding-top: 15px;
    position: absolute;
    bottom: 120px;
    z-index: 10;
    width: 100%;
   
    overflow: scroll;
    transition: all 0.2s ease-in;
    transform: translateY(calc(100% + 40px));
    .goods_boxs {
      height: 370px;
      overflow: scroll;
    }
    .title1 {
      display: inline-block;
      width: 100%;
      position: relative;
      text-align: center;
      color: #2C2C2C;
      font-size: 18px;
      img {
        position: absolute;
        width: 21px;
        height: 20px;
        right: 13px;
        top: 0px;
      }
    }
    &.show{
     transform: translateY(0%);
 
    }
    &.bottom {
       bottom: 80px;
    }
  }
 
`




// WEBPACK FOOTER //
// ./src/views/activity_136/index.js